import { render, staticRenderFns } from "./icBookingBasic.vue?vue&type=template&id=5183ebae&scoped=true&"
import script from "./icBookingBasic.vue?vue&type=script&lang=js&"
export * from "./icBookingBasic.vue?vue&type=script&lang=js&"
import style0 from "./icBookingBasic.vue?vue&type=style&index=0&id=5183ebae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5183ebae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5183ebae')) {
      api.createRecord('5183ebae', component.options)
    } else {
      api.reload('5183ebae', component.options)
    }
    module.hot.accept("./icBookingBasic.vue?vue&type=template&id=5183ebae&scoped=true&", function () {
      api.rerender('5183ebae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/pageUserUICustom/icBookingBasic.vue"
export default component.exports